<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Order Charges"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Add charges to work orders."
      @on-submit="createWorkOrderChargeImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Order Charges Template.xlsx"
              :file-provider="$importsAPI.getWorkOrderChargesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'WorkOrderChargesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'work-order-charges-imports-add-modal',
    };
  },
  methods: {
    createWorkOrderChargeImport(data, handleCreate) {
      handleCreate(this.$importsAPI.workOrderChargesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
